import { render } from "./OrderDetailContainer.vue?vue&type=template&id=21fdbade&scoped=true&ts=true"
import script from "./OrderDetailContainer.vue?vue&type=script&lang=ts"
export * from "./OrderDetailContainer.vue?vue&type=script&lang=ts"

import "./OrderDetailContainer.vue?vue&type=style&index=0&id=21fdbade&lang=sass&scoped=true"
import "./OrderDetailContainer.vue?vue&type=style&index=1&id=21fdbade&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fdbade"]])

export default __exports__